import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { colors, alertColors } from '@global/constants'

export const TITLE_FONT_SIZE = 30

export const Header = styled.header`
  background-color: #fff;
  padding: 0 50px;
  display: flex;
  flex-direction: column;
  font-family: 'Noto Sans', sans-serif;
  position: relative;
  grid-gap: 10px;

  &.-no-navlist {
    padding-bottom: 36px;
  }
`

export const Title = styled.h1`
  color: #000;
  font-size: 30px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  margin: 0;
  min-width: 200px;
`

const removeScrollbarStyle = css`
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const TitleEditable = styled(Title)`
  position: relative;
  width: auto;
  max-width: 100%;

  > * > * {
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    white-space: nowrap;
    font-size: ${TITLE_FONT_SIZE}px;
    width: 100%;

    &:focus {
      text-overflow: clip;
    }
  }

  ${removeScrollbarStyle}

  &:after {
    display: block;
    content: '';
    border-bottom: solid 1px #949494;
    transform: scaleX(0);
    transition: transform 250ms ease-in-out;
    transform-origin: 0% 50%;
  }

  &.-active-required-error:after {
    border-bottom: solid 1px ${alertColors.error};
    transform: scaleX(1);
  }

  &.-is-hovered:after {
    transform: scaleX(1);
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
  position: relative;
`

export const List = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  align-self: flex-start;
`
export const ListItem = styled.li`
  list-style: none;
  font-size: 12px;
  display: flex;
  margin-right: 20px;

  &.is-active a {
    border-bottom: 3px solid ${colors.green.light};
  }

  &.more-item a:hover {
    border-bottom: 3px solid transparent;
  }

  &:nth-last-of-type(2) a {
    padding-right: 0;
  }

  a {
    display: flex;
    align-items: center;
    padding: 5px 0;
    color: #1f2c2e;
    text-decoration: none;
    border-bottom: 3px solid transparent;
    transition: border-bottom 300ms ease-in-out;
    width: 100%;
    cursor: pointer;

    &:hover {
      border-bottom: 3px solid ${colors.green.light};
      cursor: pointer;
    }
  }
`

export const Icons = styled.div`
  display: flex;
  margin-right: 6px;

  > * {
    margin-left: 2px;
  }
`

export const ProfileMenu = styled.nav``

export const AnimatedCharacter = styled(motion.span)`
  color: ${alertColors.error};
`

export const ErrorMessage = styled(motion.div)`
  padding: 5px 0;
  position: absolute;
  bottom: -26px;
`

export const CvsAvatarStyles = css`
  height: 20px;
  line-height: 1.7;
  width: 20px;
  font-size: 12px;
  display: inline-block;
  text-align: center;
`

export const badge = css`
  background-color: #f2fcf7;
  color: #1ea16f;
  font-size: 12px;
  border-radius: 30px;
  padding: 5px 10px;
  margin-left: 20px;
`

export const badgeBlue = css`
  background-color: #ebf6ff;
  color: #0064cb;
`
